
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TermsAndConditions: React.FC = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === '/';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-32 bg-theme-bg transition-colors">
      <div className="max-w-4xl mx-auto px-6">
        <header className="mb-16">
          <span className="text-primary text-xs font-bold uppercase tracking-[0.3em]">Juridisch</span>
          <h1 className="font-display text-4xl md:text-6xl text-theme-text mt-4">Gebruiksvoorwaarden</h1>
        </header>

        <div className={`prose max-w-none space-y-12 ${isLandingPage ? 'prose-invert' : 'prose-neutral'} transition-all`}>
          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">01</span> Algemeen
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light transition-colors">
              <p>
                Deze website wordt beheerd door <strong>Dr. An De Cuyper</strong>, gevestigd te Boniverlei 174, 2650 Edegem, Antwerpen, België, tel. +32 3 284 45 39.
              </p>
              <p>
                Door deze website te bezoeken en te gebruiken, verklaart u zich uitdrukkelijk akkoord met deze gebruiksvoorwaarden, evenals met alle andere toepasselijke wettelijke bepalingen. Indien u niet akkoord gaat met deze gebruiksvoorwaarden, wordt u verzocht deze website niet te gebruiken.
              </p>
              <p>
                Dr. An De Cuyper behoudt zich het recht voor deze gebruiksvoorwaarden op elk moment te wijzigen. De meest recente versie is steeds van toepassing.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">02</span> Doel van de website
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Deze website heeft als doel:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>het verstrekken van algemene informatie over esthetische en medische behandelingen;</li>
                <li>het informeren over de praktijk van Dr. An De Cuyper;</li>
                <li>het mogelijk maken van contactopname of het aanvragen van een afspraak.</li>
              </ul>
              <p>De informatie op deze website is louter informatief en kan nooit worden beschouwd als individueel medisch advies.</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">03</span> Toegestaan gebruik
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>U mag deze website uitsluitend gebruiken voor persoonlijke, niet-commerciële doeleinden, namelijk:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>het raadplegen van informatie;</li>
                <li>het aanvragen van een afspraak;</li>
                <li>het contact opnemen met de praktijk;</li>
                <li>het volgen van links naar externe websites.</li>
              </ul>
              <p className="mt-4">Het is uitdrukkelijk verboden om:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>de website of inhoud ervan te gebruiken voor commerciële doeleinden;</li>
                <li>gegevens te kopiëren, scrapen of hergebruiken zonder schriftelijke toestemming;</li>
                <li>de website te gebruiken op een manier die de werking, veiligheid of toegankelijkheid kan schaden.</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">04</span> Medische informatie & resultaatverbintenis
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Alle behandelingen uitgevoerd door Dr. An De Cuyper zijn middelen- of inspanningsverbintenissen.</p>
              <p>Hoewel elke behandeling met de grootste zorg wordt uitgevoerd, kunnen:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>resultaten variëren van persoon tot persoon;</li>
                <li>bijwerkingen of onvoorziene reacties optreden.</li>
              </ul>
              <p>Er wordt geen garantie gegeven op een specifiek resultaat. Enkel een persoonlijk consult kan leiden tot een correcte medische inschatting.</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">05</span> Intellectuele eigendom
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Alle inhoud op deze website, waaronder maar niet beperkt tot teksten, foto’s, logo’s, grafisch ontwerp, lay-out en merknamen is beschermd door auteursrechten en andere intellectuele eigendomsrechten.</p>
              <p>Zonder voorafgaande schriftelijke toestemming van Dr. An De Cuyper is het verboden deze inhoud geheel of gedeeltelijk te kopiëren, verspreiden, wijzigen of commercieel te gebruiken.</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">06</span> Foto’s en visueel materiaal
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Afbeeldingen op deze website dienen uitsluitend ter illustratie. Voor-en-nafoto’s of vergelijkbare beelden geven geen garantie op identieke resultaten. Resultaten zijn steeds individueel en afhankelijk van biologische factoren.</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">07</span> Links naar en van de website
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Deze website kan links bevatten naar externe websites. Dr. An De Cuyper is niet verantwoordelijk voor de inhoud, het beleid of de werking van deze externe websites.</p>
              <p>Het plaatsen van links naar deze website is enkel toegestaan na voorafgaande schriftelijke toestemming.</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">08</span> Beperking van aansprakelijkheid
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>Dr. An De Cuyper kan niet aansprakelijk worden gesteld voor:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>schade voortvloeiend uit het gebruik van deze website;</li>
                <li>onjuistheden of onvolledigheden in de verstrekte informatie;</li>
                <li>tijdelijke onbeschikbaarheid of technische storingen;</li>
                <li>schade veroorzaakt door het gebruik van externe links.</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">09</span> Privacy en persoonsgegevens
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light">
              <p>De verwerking van persoonsgegevens gebeurt conform de geldende privacywetgeving (GDPR/AVG). Meer informatie hierover vindt u in de Privacyverklaring op deze website.</p>
            </div>
          </section>

          <section className="border-t border-theme-border pt-12">
            <h2 className="text-2xl font-display text-theme-text mb-6 flex items-center gap-3 transition-colors">
              <span className="text-primary text-sm font-sans font-bold">10</span> Toepasselijk recht en bevoegde rechtbank
            </h2>
            <div className="text-theme-muted leading-relaxed space-y-4 font-light transition-colors">
              <p>Op deze website en deze gebruiksvoorwaarden is uitsluitend het Belgisch recht van toepassing.</p>
              <p>In geval van een geschil zijn enkel de rechtbanken van het arrondissement Antwerpen, afdeling Antwerpen, bevoegd.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
